export default "__VITE_PUBLIC_ASSET__5aace1b2__"